<!-- Main template, wraps child components on td-wb-layout when not embedded; -->
@if (!isEmbedded) {
  <td-wb-layout [@.disabled]="animationsDisabled">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </td-wb-layout>
} @else {
  <div id="td-wb-content"
    role="main"
    tabindex="-1"
    class="td-wb-layout__page-container">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </div>
}

<!-- body of webbroker, contains ui-view -->
<ng-template #body>
  <ui-view autoscroll="true"></ui-view>
  <td-wb-export></td-wb-export>
</ng-template>

<!-- Embedded site, strips out layout (attrader scenario) -->
<ng-template #embedded>
  <div id="td-wb-content"
    role="main"
    tabindex="-1"
    class="td-wb-layout__page-container">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </div>
</ng-template>
